import { Controller } from "@hotwired/stimulus"

// Drives the 3-step "add member" wizard: shows one panel at a time with
// Back/Next navigation and validates the current panel before advancing.
export default class extends Controller {
  static targets = ["panel", "step", "prevButton", "nextButton", "submitButton"]

  connect() {
    this.index = 0
    this.show()
  }

  next() {
    if (!this.validateCurrent()) return
    if (this.index < this.panelTargets.length - 1) {
      this.index += 1
      this.show()
    }
  }

  prev() {
    if (this.index > 0) {
      this.index -= 1
      this.show()
    }
  }

  // Validates required inputs within the current panel using HTML5 validity.
  validateCurrent() {
    const panel = this.panelTargets[this.index]
    if (!panel) return true
    const fields = panel.querySelectorAll("input, select, textarea")
    for (const field of fields) {
      if (field.willValidate && !field.checkValidity()) {
        field.reportValidity()
        return false
      }
    }
    return true
  }

  show() {
    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("d-none", i !== this.index)
    })

    this.stepTargets.forEach((step, i) => {
      step.classList.toggle("active", i === this.index)
      step.classList.toggle("text-primary", i === this.index)
      step.classList.toggle("fw-bold", i === this.index)
      step.classList.toggle("text-muted", i !== this.index)
    })

    const isFirst = this.index === 0
    const isLast = this.index === this.panelTargets.length - 1

    if (this.hasPrevButtonTarget) this.prevButtonTarget.classList.toggle("d-none", isFirst)
    if (this.hasNextButtonTarget) this.nextButtonTarget.classList.toggle("d-none", isLast)
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.classList.toggle("d-none", !isLast)
  }
}
